<template>
    <MemberForm />
  </template>
  
  <script>
  import MemberForm from '@/components/team-members/MemberForm.vue';
  
  export default {
    name: "MembersCreatePage",
    components: {
      MemberForm,
    },
  };
  </script>
  